import access from '@/mixins/access'
import common from '@/mixins/common'
import queryform from '@/mixins/queryform'

export default {
  mixins: [access, common, queryform]
}
